<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">

    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <PlayersTable title="Players" :data="tableData" @deletePlayer="deletePlayer" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import PlayersTable from '@/views/Players/Tables/PlayersTable.vue';

export default {
  components: {
    PlayersTable,
  },
  data() {
    return {
      tableData: [
        {
          avatar: '',
          Name: 'User Name',
          email: 'andrew@colvins.ca',
        },
      ],
    };
  },
  mounted() {
    this.getPlayers();
  },
  methods: {
    deletePlayer(playerId) {

    },
    getPlayers() {
      this.axios
        .get('/users', {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
          params: { _limit: -1 }
        })
        .then((response) => {
          this.tableData = response.data;
        });
    },
  },
};
</script>
